import { Grid2, Typography } from "@mui/material";
import React, { ReactNode } from "react";

export const Show = ({ children }: { children: ReactNode | null }) => {
  let when: ReactNode | null = null;
  let otherwise: ReactNode | null = null;

  React.Children.toArray(children).forEach((child) => {
    const childElement = child as any;

    if (childElement.type === Show.When && childElement.props.isTrue) {
      when = childElement.props.children;
    } else if (childElement.type === Show.Else) {
      otherwise = childElement.props.children;
    }
  });

  return when !== null ? when : otherwise;
};

Show.When = ({
  isTrue,
  children,
  showNodata = false,
  extraComponent,
  textContent,
  loading = false,
  emptyIcon,
  withBorder = true,
  secondTextContent,
}: {
  isTrue: boolean;
  loading?: boolean;
  showNodata?: boolean;
  textContent?: string;
  children: ReactNode;
  extraComponent?: ReactNode;
  emptyIcon?: ReactNode;
  withBorder?: boolean;
  secondTextContent?: string;
}) => {
  if (showNodata && !isTrue && !loading) {
    return (
      <Grid2
        container
        spacing={3}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          borderRadius: 6,
          border: withBorder ? `2px dashed rgb(210 210 210)` : "none",
          width: "-webkit-fill-available",
          padding: 16,
        }}
      >
        {!!emptyIcon && (
          <Grid2 size={12} display={"flex"} justifyContent={"center"}>
            {emptyIcon}
          </Grid2>
        )}

        {extraComponent ? (
          <Grid2 size={12}>{extraComponent}</Grid2>
        ) : (
          <Grid2 size={12}>
            <Typography
              fontSize={14}
              fontWeight={700}
              textAlign={"center"}
              color="#222"
            >
              {textContent || "No details added yet"}
            </Typography>
            {!!secondTextContent && (
              <Typography
                display={"flex"}
                justifyContent={"center"}
                textAlign={"center"}
                mt={1}
                color="#697586"
                fontSize={12}
                fontWeight={500}
              >
                {secondTextContent || "No details added yet"}
              </Typography>
            )}
          </Grid2>
        )}
      </Grid2>
    );
  }
  return isTrue ? children : null;
};

Show.Else = ({ children }: { children: ReactNode }) => children;
